import { DSNCSeeAlso } from 'shared-definitions/types'
import { ApiComponentSeeAlso } from 'data-source/types.wp'
import { categoryTextMapper } from 'data-source/mappers/categoryTextMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncSeeAlso(input: ApiComponentSeeAlso, opts: PLinkMapperOpts): DSNCSeeAlso {
  return {
    text: input.text ?? null,
    resource: 'nc-see-also',
    title: input.title,
    subtitle: input.sponsored ? 'Promoted' : categoryTextMapper(input.category ?? '-'),
    image: imageMapper(input.image, opts),
    pLink: pLinkMapper(input.url, opts),
    overrideTheme: mapToTheme(input.override_theme),
    layout: mapToLayout(input.layout),
  }
}

function mapToTheme(input?: string): DSNCSeeAlso['overrideTheme'] {
  switch (input) {
    case 'lock_to_dark':
      return 'dark'
    case 'lock_to_light':
      return 'light'
    default:
      return 'inherit'
  }
}

function mapToLayout(input?: string): DSNCSeeAlso['layout'] {
  switch (input) {
    case 'big_image':
      return 'card'
    case 'large':
      return 'large'
    default:
      return 'default'
  }
}
